import React, {useState, useEffect} from 'react'
import {  InputItem , Toast, Modal} from 'antd-mobile';
import h5Share from '@/utils/h5Share'
import {verifyPhone, sendMessage, registByChannel, verifyChannelCode, getUser, register } from '@/api/user-new'
import prizeHeader from '@/img/user-new/prize-header.png'
import defaultImg from '@/img/user-new//pic_zwdw2x.png'
import { ShareContainer, RegistContainer, FormCotainer, ActivityDesc, Ctitle, Descp, Cicon, Footer, Center, RegistModalContent } from './style'
import closeIcon from '@/img/user-new/close-circle.png'
import { rsaString } from '@/utils'

const regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
function getValue(search,key) {
  //找出key第一次出现的位置
  var start = search.indexOf(key);
 
  if(start === -1) {
   return;
  }
  //找出key最后出现的位置
  var end = search.indexOf("&",start);
  if(end === -1) {
   end = search.length;
  }
  //取出键值对
  var str = search.substring(start,end);
  //获取getValue
  var arr = str.split("=");
 
  return arr[1];
  }


const SharePullRegist = ({props}) => {
  const [usename, setUsename] = useState('市值风云')
  const [value, setvalue] = useState('')
  const [code, setcode] = useState('')
  const [inviteCode, setinviteCode] = useState('')
  const [visible, setvisible] = useState(false)
  const [descVisible, setDescVisible] = useState(false)
  const [hasphone, setHasphone] = useState(false)
  const [activeId, setActiveId] = useState(null);
  const [type, setType] = useState('1')
  const [footerStatus, setFooterStatus] = useState(false)
  const [pageType, setPageType] = useState()
  let [count, setCount] = useState(60)
  const getCode = () => {
    const val = value.replace(/\s*/g,"")
    if(!regPhone.test(val)){
      Toast.info('请输入正确手机号');
    } else {
      verifyPhone({C_PHONE: rsaString(val)}).then(res=> {
        if(res.resultCode === '00'){
          setType('1')
          setvisible(false)
          sendMessage({PHONE:rsaString(val), type: '0'}).then(res=>{
            if(res.resultCode === '00'){
              setHasphone(true)
              let timer = null
              clearInterval(timer)
              timer = setInterval(()=>{
                if(count === 0) {
                  clearInterval(timer)
                  setCount(60)
                  setHasphone(false)
                } else {
                  setCount(count--)
                }
              }, 1000)
            }
          })
        } else if(res.resultCode === '01') {
          setType('2')
          setvisible(true)
        } else if(res.resultCode === '01'){
          Toast.info('请输入正确手机号')
        }
      })
     
    }

  }
  const regist = () => {
    const val = value.replace(/\s*/g,"")
    if(regPhone.test(val)){
      if (pageType && pageType === 'value') {
        const params ={
          phone: val, 
          smsCode: code,
          inviteCode: inviteCode
        }
        register(params).then(res=>{
          if(res.resultCode === '00'){
            setvisible(true)
            setType('1')
          } else {
            Toast.info(res.resultMsg);
          }
        })
      } else {
        const params ={
          phone: val, 
          smsCode: code,
          activityId: activeId, 
          channelId: inviteCode
        }
        registByChannel(params).then(res=>{
          if(res.resultCode === '00'){
            setvisible(true)
            setType('1')
          } else {
            Toast.info(res.resultMsg);
          }
        })
      }
    } else {
      Toast.info('请输入正确手机号')
    }
  }
  const openlink = () => {
    setvisible(false)
    window.location.href="https://filetest.wogoo.com/app/download/index.html"
  }

  const changeValue = val => {
    setcode(val)
  }
  const onChangePhone = val =>{
    setvalue(val)
  }
  const initPage = () => {
    setinviteCode(props.match.params.code)
    let pageType = props.match.params.type

    const {search} = props.location
    const activeId = getValue(search, "activeId")

    setPageType(pageType)
    if(activeId) {
      setActiveId(activeId)
    }
   
    let h5Message = {
      title:  `市值风云宠粉福利，《价值投资体系全景图》免费领！`, 
      desc: '浓缩专业投研思路，纯干货！',
    }
    if (props.match.params.type === 'value') {
      h5Message = {
        title:  `【市值风云6周年】送你一张价值投资体系全景图，投资必备！`, 
        desc: '价值199元高清印刷版和超大号鼠标垫限时限量免费送，先到先得！',
      }
    }
    let data = {
      title:  h5Message.title, 
      desc: h5Message.desc, 
      link: window.location.href,
      imgUrl:  'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      }
    }
    h5Share.main(data)
    if (pageType && pageType === 'value') {
      getUser({invitedCode: props.match.params.code}).then(res => {
        if (res) {
          setUsename(res)
        }
      })
    } else {
      verifyChannelCode({channelId: props.match.params.code}).then(res => {
        if (res) {
          setUsename(res)
        }
      })
    }
  }

  const handleScroll = () => {
    if (pageType && pageType === 'value') return
    if (window.scrollY > window.screen.width * 1.8) {
      setFooterStatus(true)
    } else {
      setFooterStatus(false)
    }
  }

  useEffect(() => {
    initPage()
    document.title = '限时宠粉福利'
    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.addEventListener('scroll', handleScroll)
    }
  }, [])
 
  return (
    <ShareContainer
       className={ pageType && pageType === 'value' ? 
        
       (activeId === '11' ?'value-container value_active11' : 'value-container')
        : ''
      } 

      >
      { 
      (!pageType && pageType !== 'value') && 
      <ActivityDesc onClick={() => setDescVisible(true)}>活动说明</ActivityDesc>
      }
      <div className="container">
        <RegistContainer className={pageType}>
          {usename ? <div>
            <FormCotainer>
              { (pageType && pageType === 'value') && <div className="regist-desc">登录APP即可获得高清电子版</div> }
              <div className="form-item">
                <InputItem type="phone" defaultValue={value}   editable  clear onChange={(val)=>onChangePhone(val)}>+86</InputItem>
              </div>
              <div className="form-item">
                <InputItem type="number" className={'text'} defaultValue={code} editable  clear maxLength={4} placeholder={'请输入验证码'} onChange={(val)=>changeValue(val)}/>
                {!hasphone? <div className={'button active'} onClick={()=> getCode()}>获取验证码</div>: 
                <div className={'button'}>{count} 后重新获取 </div>}
              </div>
              <button className={'regist'} onClick={()=>regist()}>立即注册</button>
            </FormCotainer>
          </div> : <Center>
            <img className="img" src={defaultImg} alt="" / >
            <div className="desc">抱歉，邀请信息不正确，无法访问</div>
          </Center>}
        </RegistContainer>
      </div>
      <Modal
        visible={visible}
        transparent
        className={'regist-modal'}
        maskClosable={true}
        onClose={()=> setvisible(false)}
        title="">
        <RegistModalContent>
          <Ctitle type={type}>
              <div className='blue-back'></div>
              <div className='title'>{type==='1'? '恭喜': '提示'}</div>
              {type==='1' ? <img className="prize-header" src={prizeHeader} alt="" /> : ''}
          </Ctitle>
          <div className={'regist-modal-content-text'}>{type==='1'? '您已经成功注册市值风云。快来与您的好友一起看行情、做交易、逛社区吧': (pageType && pageType === 'value' ? <div>该手机号已注册，请登录APP<br></br>领取《价值投资体系全景图》电子版</div> : <div>该手机号已注册过市值风云了<br/> 无需重复注册</div>)}</div>
          <div className={'regist-modal-content-group'}>
          {type ==='2' &&<div className='regist-modal-button'>
            <div className={'regist-modal-close'} onClick={()=>setvisible(false)}>关闭</div>
            <div className={'regist-modal-close'} onClick={()=>openlink()}>打开APP</div>
          </div>}
          {type ==='1' &&<div className={'regist-modal-content-button'} onClick={()=>openlink()}>打开APP</div>}
          </div>
        </RegistModalContent>
      </Modal>
      <Modal visible={descVisible} wrapClassName="lx-desc-modal-outer" className={'un-desc-modal lx-desc-modal'} transparent onClose={() => setDescVisible(false)}
      title={
        <Ctitle>
        <div className={'blue-back'}></div>
        <div className={'title'}>活动小助手</div>
        </Ctitle>
     }
      >
        {/* <Ctitle>
          <div className={'blue-back'}></div>
          <div className={'title'}>活动说明</div>
        </Ctitle> */}
        <Descp>一、活动时间</Descp>
        <Descp>2022年04月01日 00:00:00 至 2022年04月30日 23:59:59；</Descp>
        <Descp>二、活动对象</Descp>
        <Descp>新老注册用户均可在市值风云App中【我的】页面中参加活动领取相应奖励。</Descp>
        <Descp>三、活动奖励</Descp>
        <Descp>注册奖励：活动期间，新老用户只需完成注册并成功登录市值风云App，即可免费获取电子版《价值投资体系全景图》。</Descp>
        <Descp>邀请奖励：活动期间，邀请1位好友注册并登录成功，既可获得《价值投资体系全景图》纸质版一份；邀请2位好友注册并登录成功，即可获得一张定制版《价值投资体系全景图》鼠标垫。成功邀请3位好友，可以同时获得电子版、纸质版和鼠标垫。</Descp>
        <Descp>四、奖励发放</Descp>
        <Descp>电子版《价值投资体系全景图》可在app【我的】活动中心即时领取，纸质版和鼠标垫版需在成功邀请对应人数好友，获得领取资格后在活动页面中填写收件人信息。</Descp>
        <Descp>实物奖励将在收到邀请人登记收件信息的15天内完成发货。同时会通过app内部消息通知用户发货状态。用户也可通过咨询官方活动小助手获取最新信息。</Descp>
        <Descp>五、特别说明</Descp>
        <Descp>1) 因实物奖励数量有限，每人在活动期间最多可获得纸质版和鼠标垫各1份。</Descp>
        <Descp>2) 邀请好友成功说明：邀请新用户需要同时满足满足1.从未注册过市值风云，2.注册后登录市值风云app。</Descp>
        <Descp>3) 邀请人与被邀请人不可为同一用户，即：用户只可邀请好友，不可邀请自己（同一用户）作为被邀请人，否则参与资格与所得奖励均无效。同一用户是指包括但不限于同一登录账号、同一手机号、同一身份证号、同一终端设备号、同一IP或其他合理方式显示为同一用户的情形。</Descp>
        <Descp>对于以任何不正当方式参与活动的用户，包括但不限于侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、批量注册、用机器注册账户、用机器模拟客户端等，市值风云有权取消其参与和获得各种奖励的资格，对于非法所得，保留将各种奖励扣回的权利，并对账号进行永久限制。</Descp>
        <Descp>4) 一切解释权归市值风云所有。</Descp>
        <Descp>六、免责声明</Descp>
        <Descp>投资有风险，入市需谨慎！本活动不构成且不应被视为任何购买证券或其他金融产品的协议、要约、要约邀请、意见或建议。本活动的任何内容均不构成我们在投资、法律、会计或税务方面的意见，也不构成某种投资或策略是否适合于活动参与人情况的陈述，或其他任何针对活动参与人的推荐。</Descp>
        <Cicon src={closeIcon} alt=""  onClick={() => setDescVisible(false)}></Cicon>
      </Modal>
      <Footer className={footerStatus && usename ? '' : 'display'}>
        <div className="button" onClick={() => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        }}>立即注册</div>
      </Footer>
    </ShareContainer>
  )
}

export default SharePullRegist


// WEBPACK FOOTER //
// ./src/views/user-new/regist/index.js